/* The Ray Perfumes — theme.js */
window.RAY = window.RAY || {};

document.addEventListener('DOMContentLoaded', function(){
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fineHover = window.matchMedia('(hover:hover)').matches;
  window.RAY.reduceMotion = reduceMotion;
  window.RAY.fineHover = fineHover;

  /* ---------- Loader bar ---------- */
  var loader = document.getElementById('loaderBar');
  if(loader){
    requestAnimationFrame(function(){ loader.style.width = '100%'; });
    window.addEventListener('load', function(){ setTimeout(function(){ loader.style.opacity = '0'; }, 400); });
  }

  /* ---------- Intro ---------- */
  var intro = document.getElementById('intro');
  if(intro){
    if(reduceMotion || sessionStorage.getItem('ray-intro-seen')){
      intro.classList.add('hide');
    } else {
      requestAnimationFrame(function(){ intro.classList.add('animate'); });
      setTimeout(function(){ intro.classList.add('hide'); try{ sessionStorage.setItem('ray-intro-seen','1'); }catch(e){} }, 1100);
    }
  }

  /* ---------- Hero ray fan ---------- */
  var rayFan = document.getElementById('rayFan');
  if(rayFan){
    var n = 14;
    for(var i=0;i<n;i++){
      var angle = (i/(n-1)) * 70 - 35;
      var rad = angle * Math.PI/180;
      var x2 = 500 + Math.sin(rad)*420;
      var y2 = 0 + Math.cos(rad)*420 * 0.55;
      var line = document.createElementNS('http://www.w3.org/2000/svg','line');
      line.setAttribute('x1','500'); line.setAttribute('y1','0');
      line.setAttribute('x2', x2); line.setAttribute('y2', y2);
      line.setAttribute('stroke','var(--gold)'); line.setAttribute('stroke-width','0.6');
      line.style.opacity = 0;
      line.style.animation = 'rayIn 1.8s var(--ease) ' + (0.2 + i*0.045) + 's forwards';
      rayFan.appendChild(line);
    }
  }

  /* ---------- Theme (day/night) toggle ---------- */
  var root = document.documentElement;
  var toggle = document.getElementById('themeToggle');
  var knob = document.getElementById('knob');
  function applyTheme(t){
    root.setAttribute('data-theme', t);
    if(knob) knob.textContent = t === 'night' ? '\u263E' : '\u2600';
    try{ localStorage.setItem('ray-theme', t); }catch(e){}
  }
  var saved = null;
  try{ saved = localStorage.getItem('ray-theme'); }catch(e){}
  if(saved){ applyTheme(saved); }
  if(toggle){ toggle.addEventListener('click', function(){ applyTheme(root.getAttribute('data-theme') === 'night' ? 'day' : 'night'); }); }

  /* ---------- Mobile menu ---------- */
  var menuBtn = document.getElementById('menuBtn');
  var navLinks = document.getElementById('navLinks');
  if(menuBtn && navLinks){
    menuBtn.addEventListener('click', function(){ navLinks.classList.toggle('open'); });
    navLinks.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', function(){ navLinks.classList.remove('open'); }); });
  }

  /* ---------- Predictive search toggle ---------- */
  var searchBtn = document.getElementById('searchBtn');
  var searchPanel = document.getElementById('predictiveSearch');
  if(searchBtn && searchPanel){
    searchBtn.addEventListener('click', function(){
      searchPanel.classList.toggle('open');
      if(searchPanel.classList.contains('open')){
        var input = searchPanel.querySelector('input');
        if(input) input.focus();
      }
    });
  }

  /* ---------- Custom cursor ---------- */
  if(fineHover && !reduceMotion){
    var dot = document.getElementById('cursorDot');
    var ring = document.getElementById('cursorRing');
    if(dot && ring){
      var rx=0, ry=0, tx=0, ty=0;
      window.addEventListener('mousemove', function(e){
        tx = e.clientX; ty = e.clientY;
        dot.style.left = tx+'px'; dot.style.top = ty+'px';
        dot.classList.add('show'); ring.classList.add('show');
      });
      function loop(){ rx += (tx-rx)*0.16; ry += (ty-ry)*0.16; ring.style.left = rx+'px'; ring.style.top = ry+'px'; requestAnimationFrame(loop); }
      loop();
      document.querySelectorAll('a, button, .card').forEach(function(el){
        el.addEventListener('mouseenter', function(){ dot.classList.add('big'); ring.classList.add('big'); });
        el.addEventListener('mouseleave', function(){ dot.classList.remove('big'); ring.classList.remove('big'); });
      });
    }
  }

  /* ---------- Card 3D tilt ---------- */
  if(fineHover && !reduceMotion){
    document.querySelectorAll('.card').forEach(function(card){
      card.style.perspective = '600px';
      card.addEventListener('mousemove', function(e){
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = 'rotateY(' + (x*16) + 'deg) rotateX(' + (y*-16) + 'deg) translateY(-8px) translateZ(20px)';
      });
      card.addEventListener('mouseleave', function(){ card.style.transform = ''; });
    });
  }

  /* ---------- Wishlist heart (visual only, localStorage) ---------- */
  document.querySelectorAll('.wish').forEach(function(btn){
    var id = btn.getAttribute('data-wish-id');
    try{
      var saved2 = JSON.parse(localStorage.getItem('ray-wishlist') || '[]');
      if(id && saved2.indexOf(id) > -1){ btn.classList.add('active'); btn.textContent = '\u2665'; }
    }catch(e){}
    btn.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();
      btn.classList.toggle('active');
      btn.textContent = btn.classList.contains('active') ? '\u2665' : '\u2661';
      if(!id) return;
      try{
        var list = JSON.parse(localStorage.getItem('ray-wishlist') || '[]');
        var idx = list.indexOf(id);
        if(idx > -1) list.splice(idx,1); else list.push(id);
        localStorage.setItem('ray-wishlist', JSON.stringify(list));
      }catch(e){}
    });
  });

  /* ---------- Scroll reveal ---------- */
  var revealEls = document.querySelectorAll('.reveal');
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){ if(entry.isIntersecting){ entry.target.classList.add('in'); io.unobserve(entry.target); } });
    }, { threshold: 0.15 });
    revealEls.forEach(function(el){ io.observe(el); });
  } else { revealEls.forEach(function(el){ el.classList.add('in'); }); }

  /* ---------- Scroll theaters (home) ---------- */
  var theaters = Array.prototype.slice.call(document.querySelectorAll('.theater'));
  function clamp(v,min,max){ return Math.max(min, Math.min(max, v)); }
  function lerp(a,b,t){ return a + (b-a)*t; }
  var ticking = false;
  function updateTheaters(){
    var vh = window.innerHeight;
    theaters.forEach(function(t){
      var bottle = t.querySelector('.theater-visual img');
      if(!bottle) return;
      var rect = t.getBoundingClientRect();
      var total = rect.height - vh;
      if(total <= 0){ bottle.style.transform=''; bottle.style.opacity=1; return; }
      var scrolled = clamp(-rect.top, 0, total);
      var p = scrolled / total;
      if(reduceMotion){ bottle.style.transform = 'translateY(0) rotate(0deg)'; bottle.style.opacity = 1; return; }
      var settle = clamp(p / 0.45, 0, 1);
      var drop = lerp(-70, 0, settle);
      var rot = lerp(-10, 0, settle);
      var scale = lerp(0.9, 1, settle);
      var op = clamp(p / 0.18, 0, 1);
      var exit = p > 0.82 ? (p - 0.82) / 0.18 : 0;
      var exitLift = lerp(0, -40, exit);
      var exitOp = 1 - exit;
      bottle.style.transform = 'translateY(' + (drop + exitLift) + 'px) rotate(' + rot + 'deg) scale(' + scale + ')';
      bottle.style.opacity = Math.min(op, exitOp);
    });
    ticking = false;
  }
  if(theaters.length){
    window.addEventListener('scroll', function(){ if(!ticking){ requestAnimationFrame(updateTheaters); ticking = true; } }, { passive:true });
    updateTheaters();
  }

  /* ---------- Catalog filter + sort ---------- */
  var chipRow = document.getElementById('chipRow');
  var catalogGrid = document.getElementById('catalogGrid');
  if(chipRow && catalogGrid){
    var chips = chipRow.querySelectorAll('.chip');
    var cards = Array.prototype.slice.call(catalogGrid.querySelectorAll('.card'));
    var count = document.getElementById('resultCount');
    function applyFilter(){
      var active = chipRow.querySelector('.chip.active');
      var filter = active ? active.getAttribute('data-filter') : 'all';
      var visible = 0;
      cards.forEach(function(c){
        var show = filter === 'all' || (c.getAttribute('data-cat') || '').split(',').indexOf(filter) > -1;
        c.style.display = show ? '' : 'none';
        if(show) visible++;
      });
      if(count) count.textContent = visible + (visible === 1 ? ' fragrance' : ' fragrances');
    }
    chips.forEach(function(chip){
      chip.addEventListener('click', function(ev){
        ev.preventDefault();
        chips.forEach(function(c){ c.classList.remove('active'); });
        chip.classList.add('active');
        applyFilter();
      });
    });
    var sortSelect = document.getElementById('sortSelect');
    if(sortSelect){
      sortSelect.addEventListener('change', function(){
        var val = sortSelect.value;
        var sorted = cards.slice().sort(function(a,b){
          if(val === 'price-asc') return parseFloat(a.getAttribute('data-price')) - parseFloat(b.getAttribute('data-price'));
          if(val === 'price-desc') return parseFloat(b.getAttribute('data-price')) - parseFloat(a.getAttribute('data-price'));
          if(val === 'rating') return parseFloat(b.getAttribute('data-rating')) - parseFloat(a.getAttribute('data-rating'));
          return 0;
        });
        sorted.forEach(function(c){ catalogGrid.appendChild(c); });
      });
    }
    applyFilter();
  }

  /* ---------- Accordion (generic, delegated) ---------- */
  document.querySelectorAll('.accordion').forEach(function(acc){
    acc.querySelectorAll('.accordion-head').forEach(function(head){
      head.addEventListener('click', function(){
        var item = head.parentElement;
        var wasOpen = item.classList.contains('open');
        acc.querySelectorAll('.accordion-item').forEach(function(i){ i.classList.remove('open'); });
        if(!wasOpen) item.classList.add('open');
      });
    });
  });

  /* ---------- Quantity selectors ---------- */
  document.querySelectorAll('.qty-control').forEach(function(ctrl){
    var input = ctrl.querySelector('input');
    var minus = ctrl.querySelector('.qty-minus');
    var plus = ctrl.querySelector('.qty-plus');
    if(!input) return;
    if(minus) minus.addEventListener('click', function(){ input.value = Math.max(1, (parseInt(input.value,10)||1) - 1); });
    if(plus) plus.addEventListener('click', function(){ input.value = Math.min(20, (parseInt(input.value,10)||1) + 1); });
  });

  /* ---------- Cart drawer (built from real Shopify cart data) ---------- */
  function ensureDrawer(){
    if(document.getElementById('cartDrawer')) return;
    var overlay = document.createElement('div');
    overlay.className = 'cart-drawer-overlay';
    overlay.id = 'cartDrawerOverlay';
    var drawer = document.createElement('div');
    drawer.className = 'cart-drawer';
    drawer.id = 'cartDrawer';
    drawer.innerHTML =
      '<div class="cart-drawer-head"><h3>Your bag</h3><button class="cart-drawer-close" id="cartDrawerClose" aria-label="Close">\u00d7</button></div>' +
      '<div class="cart-drawer-body" id="cartDrawerBody"><div class="cart-drawer-loading">Loading\u2026</div></div>' +
      '<div class="cart-drawer-foot" id="cartDrawerFoot"></div>';
    document.body.appendChild(overlay);
    document.body.appendChild(drawer);
    overlay.addEventListener('click', closeCart);
    document.getElementById('cartDrawerClose').addEventListener('click', closeCart);
  }

  function renderCartFromData(cart){
    ensureDrawer();
    var body = document.getElementById('cartDrawerBody');
    var foot = document.getElementById('cartDrawerFoot');
    if(!cart.items.length){
      body.innerHTML = '<div class="cart-drawer-empty">Your bag is empty.<br><br><span style="font-size:0.85rem;">Add a fragrance to see it here.</span></div>';
      foot.innerHTML = '';
      updateCartCount(cart.item_count);
      return;
    }
    body.innerHTML = cart.items.map(function(it){
      return '<div class="cart-line">' +
        '<img src="' + (it.image || '') + '" alt="' + it.product_title + '">' +
        '<div class="cart-line-info"><div class="name">' + it.product_title + '</div><div class="meta">' + it.variant_title + ' \u00b7 Qty ' + it.quantity + '</div>' +
        '<button class="cart-line-remove" data-key="' + it.key + '">Remove</button></div>' +
        '<div class="price">' + moneyFmt(it.final_line_price) + '</div>' +
      '</div>';
    }).join('');
    foot.innerHTML = '<div class="subtotal-row"><span>Subtotal</span><span>' + moneyFmt(cart.total_price) + '</span></div>' +
      '<a href="/cart" class="btn ghost sm" style="margin-right:10px;">View bag</a>' +
      '<a href="/checkout" class="btn sm">Checkout</a>';
    body.querySelectorAll('.cart-line-remove').forEach(function(btn){
      btn.addEventListener('click', function(){
        var key = btn.getAttribute('data-key');
        fetch('/cart/change.js', {
          method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ id:key, quantity:0 })
        }).then(function(r){ return r.json(); }).then(renderCartFromData);
      });
    });
    updateCartCount(cart.item_count);
  }
  function moneyFmt(cents){
    if(window.Shopify && window.Shopify.formatMoney){ return window.Shopify.formatMoney(cents, window.Shopify.money_format || '${{amount}}'); }
    return '$' + (cents/100).toFixed(2);
  }
  function updateCartCount(n){ document.querySelectorAll('.cart-count').forEach(function(b){ b.textContent = n; }); }
  function refreshCart(){ return fetch('/cart.js').then(function(r){ return r.json(); }).then(renderCartFromData); }
  function openCart(){ ensureDrawer(); refreshCart(); document.getElementById('cartDrawerOverlay').classList.add('open'); document.getElementById('cartDrawer').classList.add('open'); }
  function closeCart(){
    var o = document.getElementById('cartDrawerOverlay'); var d = document.getElementById('cartDrawer');
    if(o) o.classList.remove('open'); if(d) d.classList.remove('open');
  }
  ensureDrawer();
  refreshCart();
  document.querySelectorAll('[data-cart-open]').forEach(function(b){
    b.addEventListener('click', function(e){ e.preventDefault(); openCart(); });
  });

  /* ---------- 3D showcase (hero + PDP gallery) ---------- */
  document.querySelectorAll('.showcase3d').forEach(function(el){
    var bottle = el.querySelector('.showcase3d-bottle');
    if(!bottle || reduceMotion || !fineHover) return;
    el.addEventListener('mousemove', function(e){
      var r = el.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      bottle.classList.add('dragging');
      bottle.style.transform = 'rotateY(' + (x*46) + 'deg) rotateX(' + (y*-34) + 'deg) translateZ(30px)';
    });
    el.addEventListener('mouseleave', function(){ bottle.classList.remove('dragging'); bottle.style.transform = ''; });
  });

  /* ---------- Add to cart (Shopify Ajax API) — now opens the cart drawer ---------- */
  document.querySelectorAll('[data-add-to-cart-form], #pdpForm, .shopify-product-form').forEach(function(form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var originalText = btn ? btn.textContent : '';
      if(btn){ btn.disabled = true; btn.textContent = 'Adding...'; }
      var formData = new FormData(form);
      fetch('/cart/add.js', { method:'POST', body: formData, headers: { 'Accept':'application/json' } })
        .then(function(res){ return res.json(); })
        .then(function(){
          if(btn){ btn.textContent = 'Added \u2713'; }
          openCart();
          setTimeout(function(){ if(btn){ btn.disabled = false; btn.textContent = originalText; } }, 1600);
        })
        .catch(function(){
          if(btn){ btn.disabled = false; btn.textContent = originalText; }
        });
    });
  });

  /* ---------- Cart line quantity update (cart page) ---------- */
  document.querySelectorAll('[data-cart-qty]').forEach(function(input){
    input.addEventListener('change', function(){
      var key = input.getAttribute('data-cart-qty');
      var qty = Math.max(0, parseInt(input.value,10) || 0);
      fetch('/cart/change.js', {
        method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ id:key, quantity:qty })
      }).then(function(){ window.location.reload(); });
    });
  });
  document.querySelectorAll('[data-cart-remove]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      var key = btn.getAttribute('data-cart-remove');
      fetch('/cart/change.js', {
        method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ id:key, quantity:0 })
      }).then(function(){ window.location.reload(); });
    });
  });

  /* ---------- Product gallery thumbs ---------- */
  var galleryMain = document.getElementById('pdpMainImg');
  if(galleryMain){
    document.querySelectorAll('.thumb[data-full]').forEach(function(thumb){
      thumb.addEventListener('click', function(){
        document.querySelectorAll('.thumb').forEach(function(t){ t.classList.remove('active'); });
        thumb.classList.add('active');
        galleryMain.style.opacity = 0;
        setTimeout(function(){
          galleryMain.src = thumb.getAttribute('data-full');
          galleryMain.style.opacity = 1;
        }, 180);
      });
    });
  }

  /* ---------- Native variant picker (size/option variants) — supports both a <select id="variantSelect"> and swatch buttons (.variant-swatch[data-variant-id]) ---------- */
  var variantSelect = document.getElementById('variantSelect');
  var variantDataTag = document.getElementById('variantData');
  var priceEl = document.getElementById('pdpPrice');
  var compareEl = document.getElementById('pdpComparePrice');
  var hiddenId = document.getElementById('pdpVariantId');
  var addBtn = document.getElementById('addToBagBtn');
  function money(cents){ return '$' + (cents/100).toFixed(2); }

  if(variantSelect && variantDataTag){
    var variants = JSON.parse(variantDataTag.textContent || '[]');
    function onVariantChange(){
      var id = variantSelect.value;
      var v = variants.filter(function(x){ return String(x.id) === String(id); })[0];
      if(!v) return;
      if(hiddenId) hiddenId.value = v.id;
      if(priceEl) priceEl.textContent = money(v.price);
      if(compareEl){
        if(v.compare_at_price && v.compare_at_price > v.price){ compareEl.textContent = money(v.compare_at_price); compareEl.style.display=''; }
        else { compareEl.style.display = 'none'; }
      }
      if(addBtn){
        if(v.available){ addBtn.disabled = false; addBtn.textContent = 'Add to bag'; }
        else { addBtn.disabled = true; addBtn.textContent = 'Sold out'; }
      }
    }
    variantSelect.addEventListener('change', onVariantChange);
    onVariantChange();
  }

  var variantSwatchRow = document.getElementById('variantSwatchRow');
  if(variantSwatchRow){
    var swatches = variantSwatchRow.querySelectorAll('.variant-swatch');
    swatches.forEach(function(sw){
      sw.addEventListener('click', function(){
        if(sw.getAttribute('data-available') === 'false'){ return; }
        swatches.forEach(function(s){ s.classList.remove('active'); });
        sw.classList.add('active');
        if(hiddenId) hiddenId.value = sw.getAttribute('data-variant-id');
        if(priceEl) priceEl.textContent = sw.getAttribute('data-price');
        var img = sw.getAttribute('data-image');
        var mainImg = document.getElementById('pdpMainImg');
        if(img && mainImg){
          mainImg.style.opacity = 0;
          setTimeout(function(){ mainImg.src = img; mainImg.style.opacity = 1; }, 180);
        }
        if(addBtn){
          if(sw.getAttribute('data-available') === 'true'){ addBtn.disabled = false; addBtn.textContent = 'Add to bag'; }
          else { addBtn.disabled = true; addBtn.textContent = 'Sold out'; }
        }
      });
    });
  }

  /* ---------- Product page quantity stepper (span display + hidden form input) ---------- */
  var qtyValSpan = document.getElementById('qtyVal');
  if(qtyValSpan){
    var qtyMinusBtn = document.getElementById('qtyMinus');
    var qtyPlusBtn = document.getElementById('qtyPlus');
    var hiddenQtyInput = qtyValSpan.closest('form') ? qtyValSpan.closest('form').querySelector('input[name="quantity"]') : null;
    function syncQty(v){
      qtyValSpan.textContent = v;
      if(hiddenQtyInput) hiddenQtyInput.value = v;
    }
    if(qtyMinusBtn) qtyMinusBtn.addEventListener('click', function(){ syncQty(Math.max(1, (parseInt(qtyValSpan.textContent,10)||1) - 1)); });
    if(qtyPlusBtn) qtyPlusBtn.addEventListener('click', function(){ syncQty(Math.min(20, (parseInt(qtyValSpan.textContent,10)||1) + 1)); });
  }

  /* ---------- Review star picker + local review submit ---------- */
  var starPicker = document.getElementById('starPicker');
  if(starPicker){
    var picked = 5;
    var starEls = starPicker.querySelectorAll('span');
    function paint(v){ starEls.forEach(function(s){ s.classList.toggle('sel', parseInt(s.getAttribute('data-v'),10) <= v); }); }
    paint(picked);
    starEls.forEach(function(s){ s.addEventListener('click', function(){ picked = parseInt(s.getAttribute('data-v'),10); paint(picked); }); });

    var submitBtn = document.getElementById('submitReview');
    if(submitBtn){
      submitBtn.addEventListener('click', function(){
        var nameEl = document.getElementById('revName');
        var textEl = document.getElementById('revText');
        var text = (textEl.value || '').trim();
        if(!text){ textEl.focus(); return; }
        var productId = starPicker.getAttribute('data-product-id') || 'general';
        var card = document.createElement('div');
        card.className = 'review-card';
        card.innerHTML = '<div class="review-head"><div class="review-name">' + (nameEl.value || 'Anonymous') + '</div><div class="review-date">Just now</div></div>' +
          '<div class="stars" style="margin-bottom:8px;">' + '\u2605'.repeat(picked) + '\u2606'.repeat(5-picked) + '</div>' +
          '<div class="review-text">' + text + '</div>';
        var list = document.getElementById('reviewList');
        if(list) list.insertBefore(card, list.firstChild);
        try{
          var stored = JSON.parse(localStorage.getItem('ray-reviews-'+productId) || '[]');
          stored.unshift({ name:nameEl.value||'Anonymous', rating:picked, text:text, date:'Just now' });
          localStorage.setItem('ray-reviews-'+productId, JSON.stringify(stored));
        }catch(e){}
        nameEl.value=''; textEl.value='';
        var toast = document.getElementById('revToast');
        if(toast){ toast.classList.add('show'); setTimeout(function(){ toast.classList.remove('show'); }, 3000); }
      });
    }

    /* restore locally-added reviews for this product on load */
    try{
      var pid = starPicker.getAttribute('data-product-id') || 'general';
      var restored = JSON.parse(localStorage.getItem('ray-reviews-'+pid) || '[]');
      var list2 = document.getElementById('reviewList');
      if(list2 && restored.length){
        restored.reverse().forEach(function(r){
          var card = document.createElement('div');
          card.className = 'review-card';
          card.innerHTML = '<div class="review-head"><div class="review-name">' + r.name + '</div><div class="review-date">' + r.date + '</div></div>' +
            '<div class="stars" style="margin-bottom:8px;">' + '\u2605'.repeat(r.rating) + '\u2606'.repeat(5-r.rating) + '</div>' +
            '<div class="review-text">' + r.text + '</div>';
          list2.insertBefore(card, list2.firstChild);
        });
      }
    }catch(e){}
  }

  /* ---------- Newsletter / contact form demo success states ---------- */
  document.querySelectorAll('[data-demo-success]').forEach(function(form){
    form.addEventListener('submit', function(e){
      var btn = form.querySelector('button[type="submit"]');
      if(btn){ e.preventDefault(); btn.textContent = form.getAttribute('data-demo-success'); }
    });
  });
});
